import React from 'react';
import { GlobeIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="bg-carbon py-16 md:py-20" aria-labelledby="final-cta-title" data-id="element-38" data-mp="3udp1swq2twsn">
      <div className="mx-auto max-w-[1080px] px-5" data-id="element-39" data-mp="c7k4huqyqhna">
        <div className="mx-auto max-w-[480px] text-center" data-id="element-40" data-mp="85fdz4vta14v">
          <h2 id="final-cta-title" className="text-[26px] leading-[1.15] text-ink-light sm:text-[34px]" data-id="element-41" data-mp="83vw59uibi0z">
            ¿Listo para generar{' '}
            <span className="text-gold" data-id="element-42" data-mp="h52gju0a1czi">atracción real</span>?
          </h2>
          <p className="mx-auto mt-4 max-w-[400px] text-[12px] font-medium leading-relaxed text-ink-light/60 md:text-[13px]" data-id="element-43" data-mp="vv9srrzoxzrr">
            6 tomos. 5 herramientas adicionales. Un sistema práctico para
            trabajar seguridad, comunicación e intención desde hoy.
          </p>
          <div className="mx-auto mt-7 max-w-[340px]" data-id="element-44" data-mp="zwmw9vfb9qvi">
            <CTAButton label="Sí — quiero el Mega Pack completo" data-id="element-45" data-mp="zxxwxmdgmiie" />
          </div>
          <p className="mt-3 text-[10px] font-medium text-ink-light/50" data-id="element-46" data-mp="2c5yavq9tyney">
            US$19 pago único · Garantía de 7 días · Acceso inmediato
          </p>
          <p className="mt-1.5 flex items-center justify-center gap-1.5 text-[10px] font-medium text-ink-light/35" data-id="element-47" data-mp="2m2ud5e94ydb2">
            <GlobeIcon className="h-3 w-3 flex-none" aria-hidden="true" data-id="element-48" data-mp="2r2gpllh53pit" />
            El precio final se mostrará en tu moneda local.
          </p>
        </div>
      </div>
    </section>;
}